// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunks/" + (chunkId === "5005" ? "common" : chunkId) + "." + {"5005": "e8c7a640","6902": "df2ac4f1",}[chunkId] + ".css"
}